import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'AnyTokenSwap',
  description:
    'AnyTokenSwap Is Decenteralized exchange on binance smart chain.',
  image: 'https://anytokenswap.netlify.app/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('AnyTokenSwap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('AnyTokenSwap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('AnyTokenSwap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('AnyTokenSwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('AnyTokenSwap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('AnyTokenSwap')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('AnyTokenSwap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('AnyTokenSwap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('AnyTokenSwap')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('AnyTokenSwap')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('AnyTokenSwap')}`,
      }
    default:
      return null
  }
}
